<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/H0WfRR/tc-custom/9781466862869.jpg?1733104150776" alt="This image is the cover for the book Sucker's Kiss"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sucker's Kiss
      </h1>
      <p class="bookDescription body article font2">
        <p>During the San Francisco earthquake of 1906, seven-year-old Thomas Moran finds himself accidentally embarking on a career in pickpocketing. In the following years he becomes a master of his dubious craft and grows to manhood traveling from state to state across America. <br/><br/>His picaresque journey takes him through Prohibition and the Depression; into the desperate highs of the Hootchy-Kootchy and the dying vineyards of California, accompanied by an array of richly drawn characters frantically clutching at the crumbling American dream. Italian and Chinese gangsters, con artists, corrupt clergy, and speakeasy bootleggers all have a part to play in Tommy's destiny, but it is Effie, the great love of his life, who offers him the chance to change his future, and tries to save him from himself. <br/><br/>Colorfully written, engaging, and richly evocative of an extraordinary period in American history, <i>The Sucker's Kiss</i> marks the literary debut of master storyteller Alan Parker.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alan Parker
      </h2>
      
      <p class="authorDescription body article"><P><B>Alan Parker</B>---director, writer, and producer---directed his first film, <I>Bugsy Malone</I>, in 1975. His other films include <I>Midnight Express</I>, <I>Fame</I>, <I>Birdy</I>, <I>Mississippi Burning</I>, <I>The Commitments</I>, and <I>Angela's Ashes</I>. The numerous accolades for his work include nineteen British Film Academy awards, ten Golden Globe awards, and six Oscars. Parker was knighted in 2002 for services to the British film industry.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Dunne Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?965bb026